'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BaseContentCard = require('../BaseContentCard');

var _BaseContentCard2 = _interopRequireDefault(_BaseContentCard);

var _BaseContentCardPaywall = require('../BaseContentCardPaywall');

var _BaseContentCardPaywall2 = _interopRequireDefault(_BaseContentCardPaywall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBaseContentMeta = function getBaseContentMeta(externalLink, externalSource, author, publishedDateTime) {
  var metaText = 'By ' + author + ' \u2022 ' + publishedDateTime;
  if (externalSource && externalLink === 'External URL') {
    metaText = 'Via ' + externalSource + ' \u2022 ' + publishedDateTime;
  }
  return metaText;
};

var EditorialArticleCard = function EditorialArticleCard(_ref) {
  var author = _ref.author,
      publishedDateTime = _ref.publishedDateTime,
      title = _ref.title,
      subtitle = _ref.subtitle,
      permalink = _ref.permalink,
      media = _ref.media,
      tags = _ref.tags,
      showPaywall = _ref.showPaywall,
      funnelUrl = _ref.funnelUrl,
      onClickContent = _ref.onClickContent,
      onClickPaywall = _ref.onClickPaywall,
      onClickTag = _ref.onClickTag,
      externalLink = _ref.externalLink,
      externalSource = _ref.externalSource,
      newWindow = _ref.newWindow;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-editorial-article-card' },
    _react2.default.createElement(
      _BaseContentCard2.default,
      {
        meta: getBaseContentMeta(externalLink, externalSource, author, publishedDateTime),
        tags: tags,
        onClickTag: onClickTag,
        showPaywall: showPaywall
      },
      showPaywall ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          title
        ),
        _react2.default.createElement(_BaseContentCardPaywall2.default, {
          funnelUrl: funnelUrl,
          onClick: onClickPaywall,
          message: 'Unlock Premium Content'
        })
      ) : _react2.default.createElement(
        'a',
        { href: permalink, onClick: onClickContent, target: newWindow ? '_blank' : '_self' },
        _react2.default.createElement(
          'h2',
          null,
          title
        ),
        _react2.default.createElement(
          'p',
          { className: 'quiver-editorial-article-card__subtitle' },
          subtitle
        ),
        media ? _react2.default.createElement('div', {
          className: 'quiver-editorial-article-card__media',
          style: {
            backgroundImage: 'url(' + media.feed2x + ')'
          }
        }) : null
      )
    )
  );
};

EditorialArticleCard.propTypes = {
  author: _propTypes2.default.string.isRequired,
  publishedDateTime: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired,
  subtitle: _propTypes2.default.string,
  permalink: _propTypes2.default.string.isRequired,
  media: _propTypes2.default.shape({
    feed2x: _propTypes2.default.string.isRequired
  }),
  tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    url: _propTypes2.default.string.isRequired
  })).isRequired,
  showPaywall: _propTypes2.default.bool,
  funnelUrl: _propTypes2.default.string,
  onClickContent: _propTypes2.default.func,
  onClickPaywall: _propTypes2.default.func,
  onClickTag: _propTypes2.default.func,
  externalLink: _propTypes2.default.string,
  externalSource: _propTypes2.default.string,
  newWindow: _propTypes2.default.bool
};

EditorialArticleCard.defaultProps = {
  subtitle: null,
  media: null,
  showPaywall: false,
  funnelUrl: null,
  onClickContent: null,
  onClickPaywall: null,
  onClickTag: null,
  externalLink: null,
  externalSource: null,
  newWindow: false
};

exports.default = EditorialArticleCard;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/EditorialArticleCard/EditorialArticleCard.js
// module id = 572
// module chunks = 11